import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/sports', label: t('nav.category') },
    { to: '/article/article-1', label: t('nav.articles') },
    { to: '/about', label: t('nav.about') },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="font-heading text-xl md:text-2xl font-bold text-primary-600 tracking-tight">
              kaiyun
            </span>
            <span className="hidden sm:inline text-sm text-foreground-500 font-medium">
              com
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {link.label}
                {location.pathname === link.to && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('nav.login')}
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('nav.register')}
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-2 mt-2 pt-3 border-t border-background-200/70">
              <Link
                to="/about"
                className="flex-1 px-4 py-2.5 text-center text-sm font-medium text-foreground-700 bg-background-100 hover:bg-background-200 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('nav.login')}
              </Link>
              <Link
                to="/about"
                className="flex-1 px-4 py-2.5 text-center text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('nav.register')}
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}